import React, { lazy } from 'react';

import { IContentTemplateData } from '../types';

import DeferredBlock from '../primitives/DeferredBlock';

const SkyMomentBlock = lazy(() => import('../blocks/SkyMomentBlock'));

interface ISkyMomentProps {
    data: IContentTemplateData;
}

const SkyMoment: React.FC<ISkyMomentProps> = ({ data }) => (
    <DeferredBlock
        region="sky-moment"
        className="content-block content-block--sky-moment"
        placeholderHeight={320}
    >
        <SkyMomentBlock title={data.skyMoment.title} date={data.skyMoment.date} />
    </DeferredBlock>
);

export default SkyMoment;
